import React from 'react';
import { CompleteKundali, Language } from '../types/kundali';
import { getPlanetFullName } from '../utils/language';

interface KarkaViewProps {
  kundali: CompleteKundali;
  lang?: Language;
}

export const KarkaView: React.FC<KarkaViewProps> = ({ kundali, lang = 'en' }) => {
  const isHi = lang === 'hi';
  const charaKarakas = kundali.charaKarakas || [];

  return (
    <div className="space-y-6">
      <div className="bg-astro-bg p-6 rounded-xl border border-astro-primary/20">
        <h3 className="font-bold text-astro-primary font-serif text-lg mb-2">
          {isHi ? 'जैमिनी चर कारक एवं उपचारात्मक मार्गदर्शन' : 'Chara Karakas (Significators)'}
        </h3>
        <p className="text-sm text-astro-text mb-4">
          {isHi
            ? 'चर कारक जातक की कुंडली में ग्रहों के सर्वाधिक अंशों के आधार पर निर्धारित होते हैं, जो जीवन के विशिष्ट क्षेत्रों एवं कार्मिक संबंधों का प्रतिनिधित्व करते हैं (आत्मकारक, अमात्यकारक, भ्रातृकारक, मातृकारक, पितृकारक, पुत्रकारक, ज्ञातिकारक)।'
            : 'Chara Karakas represent the temporary status of planets based on their degrees in the chart, signifying specific areas of life and karmic relationships. The 7 main Karakas derive their influence from their highest longitude in the zodiac.'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {charaKarakas.map((ck) => {
          const needsRemedy = ck.planet !== 'Sun' && ck.planet !== 'Moon';
          
          return (
            <div key={ck.code} className="bg-white border border-astro-border rounded-xl p-4 shadow-sm">
              <div className="flex justify-between items-start mb-2">
                <h4 className="font-bold text-astro-primary text-base">{ck.code} ({ck.name})</h4>
                <span className="text-xs font-mono bg-astro-primary/10 text-astro-primary px-2 py-0.5 rounded">
                  {ck.degree ? `${ck.degree.toFixed(2)}°` : 'N/A'}
                </span>
              </div>
              <p className="text-sm text-astro-text mb-1 font-medium">
                {isHi ? 'ग्रह' : 'Planet'}: {getPlanetFullName(ck.planet as any, lang)}
              </p>
              <p className="text-xs text-astro-secondary-text mb-3">{ck.significatorFor}</p>
              
              <div className={`text-xs p-3 rounded-lg border ${needsRemedy ? 'bg-astro-secondary-surface border-[#E2DED5]' : 'bg-emerald-50 border-emerald-200'}`}>
                <p className="font-bold mb-1 flex items-center gap-1">
                  {needsRemedy ? (isHi ? 'उपाय / सामर्थ्य वृद्धि अनुशंसित' : 'Remedy Required') : (isHi ? 'सुस्थित / अनुकूल' : 'Well-positioned / Neutral')}
                </p>
                <p className="text-astro-text">
                  {needsRemedy 
                    ? isHi 
                      ? `${getPlanetFullName(ck.planet as any, lang)} को इस कारक के शुभ प्रभाव बढ़ाने के लिए मजबूत करें। ${ck.remedy || 'इस ग्रह से संबंधित दान या मंत्र जाप करें।'}`
                      : `Strengthen ${ck.planet} to enhance the positive effects of this Karaka. ${ck.remedy || 'Perform charity related to this planet.'}`
                    : isHi
                      ? 'यह कारक प्राकृतिक रूप से समर्थित है तथा किसी विशेष उपाय की आवश्यकता नहीं है।'
                      : 'This Karaka is naturally supported and may not require intensive remedies unless specifically afflicted.'
                  }
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
